var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { animationDuration } from '../drawerConsts';
export var DrawerBackdrop = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  transition: opacity ", " ease-in-out;\n  will-change: opacity;\n\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  transition: opacity ", " ease-in-out;\n  will-change: opacity;\n\n  ",
    "\n"])), animationDuration, function (_a) {
    var isOpen = _a.isOpen;
    return isOpen
        ? null
        : css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          opacity: 0;\n        "], ["\n          opacity: 0;\n        "])));
});
var templateObject_1, templateObject_2;
